import React, {useEffect, useState} from 'react'
import {Group, Layer, Rect, Stage} from "react-konva";
import TextShape from "./layers/text-shape";
import URLImage from "./image/url-image";
import ImageItem from "../konva-examples/shapes/image-item";
import reactImageSize from 'react-image-size';

function downloadURI(uri, name) {
    let link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const initialRectangles = [
    {
        x: 10,
        y: 10,
        width: 100,
        height: 100,
        fill: 'red',
        id: 'rect1',
    },
    {
        x: 150,
        y: 150,
        width: 100,
        height: 100,
        fill: 'green',
        id: 'rect2',
    },
];

/*const stageWidth = quote.settings.width * 3 / 4;
const stageHeight = quote.settings.height * 3 / 4;*/
const blockSnapSize = 30;
const WIDTH = 30;
const HEIGHT = 30;

function generateGridLinesX(stageWidth, stageHeight, stagePosition) {
    console.log('generateGridLinesX() - stagePosition: ', stagePosition);
    const padding = blockSnapSize;
    const gridLines = [];
    for (let i = stagePosition.x; i < stageWidth / padding; i++) {
        gridLines.push({
            points: [Math.round(i * padding) + 0.5, stagePosition.y, Math.round(i * padding) + 0.5, stageHeight],
            stroke: '#ddd',
            strokeWidth: 1,
        });
    }

    return gridLines;
}

function generateGridLinesY(stageWidth, stageHeight, stagePosition) {
    console.log('generateGridLinesY() - stagePosition: ', stagePosition);
    const padding = blockSnapSize;
    const gridLinesY = [];
    for (let j = stagePosition.y; j < stageHeight / padding; j++) {
        gridLinesY.push({
            points: [stagePosition.x, Math.round(j * padding), stageWidth, Math.round(j * padding)],
            stroke: '#ddd',
            strokeWidth: 0.5,
        });
    }

    return gridLinesY;
}

/*const GRID_LINES_X = generateGridLinesX();
const GRID_LINES_Y = generateGridLinesY();*/

function generateGridComponents(stageWidth, stageHeight, startX, endX, startY, endY) {
    const gridComponents = [];
    let i = 0;
    for (let x = startX; x < endX; x += WIDTH) {
        for (let y = startY; y < endY; y += HEIGHT) {
            if (i === 4) {
                i = 0;
            }

            /* const indexX = Math.abs(x / WIDTH) % grid.length;
             const indexY = Math.abs(y / HEIGHT) % grid[0].length;*/

            gridComponents.push(
                <Rect
                    key={x + '-' + y}
                    x={x}
                    y={y}
                    width={WIDTH}
                    height={HEIGHT}
                    stroke='#ddd'
                    strokeWidth={0.5}
                />
            );
        }
    }

    return gridComponents;
}


const QuoteKonvaEditor = ({
                              quote,
                              setQuote,
                              selectedDisplayText,
                              handleSelectedDisplayTextTab,
                              currentImage,
                          }) => {
    const stageRef = React.useRef(null);
    const layerRef = React.useRef(null);
    const gridLayerRef = React.useRef(null);
    const [stagePos, setStagePos] = useState({x: 0, y: 0});
    const [stageScale, setStageScale] = useState(1);
    const [images, setImages] = React.useState([]);
    const [imageDetail, setImageDetail] = React.useState(null);
    const [selectedImage, setSelectedImage] = React.useState(null);

    /* const [gridLinesX, setGridLinesX] = useState(generateGridLinesX(quote.settings.width, quote.settings.height, stagePos));
     const [gridLinesY, setGridLinesY] = useState(generateGridLinesY(quote.settings.width, quote.settings.height, stagePos));
 */
    /*    const [gridLinesX, setGridLinesX] = useState(GRID_LINES_X);
        const [gridLinesY, setGridLinesY] = useState(GRID_LINES_Y);*/

    const [gridComponents, setGridComponents] = useState(null);
    const [stageWidth, setStageWidth] = useState(quote.settings.width);
    const [stageHeight, setStageHeight] = useState(quote.settings.height);
    const [rectangles, setRectangles] = useState(initialRectangles);
    const [selectedId, selectShape] = useState(null);


    useEffect(() => {
        /*setStageWidth(quote.settings.width);
        setStageHeight(quote.settings.height);*/

        /* setStageWidth(quote.settings.width);
         setStageHeight(quote.settings.height);

         let container = document.querySelector('#stage-parent');

         // now we need to fit stage into parent container
         // @ts-ignore
         let containerWidth = container.offsetWidth;

         console.dir({container});

         // but we also make the full scene visible
         // so we need to scale all objects on canvas
         let scale = containerWidth / quote.settings.width;

         console.dir({scale});

         const stage = stageRef.current;
         stage.width(quote.settings.width * scale);
         stage.height(quote.settings.height * scale);
         stage.scale({x: scale, y: scale});*/
        const stage = stageRef.current;
        const currentScale = stage.scaleX() || 1.02;
        stage.width(quote.settings.width * currentScale);
        stage.height(quote.settings.height * currentScale);
        stage.scale({x: currentScale, y: currentScale});

        drawGrid();
    }, [quote.settings.width, quote.settings.height, stagePos]);

    useEffect(() => {
        if (selectedDisplayText) {
            selectShape(selectedDisplayText.itemKey);
        } else {
            selectShape(null);
        }
    }, [selectedDisplayText]);

    const drawGrid = () => {
        const startX = Math.floor((-stagePos.x - quote.settings.width) / WIDTH) * WIDTH;
        const endX =
            Math.floor((-stagePos.x + quote.settings.width * 2) / WIDTH) * WIDTH;

        const startY =
            Math.floor((-stagePos.y - quote.settings.height) / HEIGHT) * HEIGHT;
        const endY =
            Math.floor((-stagePos.y + quote.settings.height * 2) / HEIGHT) * HEIGHT;
        /*setGridLinesX(generateGridLinesX(quote.settings.width, quote.settings.height, stagePos));
        setGridLinesY(generateGridLinesY(quote.settings.width, quote.settings.height, stagePos));*/
        const tempGrid = generateGridComponents(stageWidth, stageHeight, startX, endX, startY, endY);
        setGridComponents(tempGrid);
    }

    const checkDeselect = (e) => {
        // deselect when clicked on empty area
        const clickedOnEmpty = e.target === e.target.getStage();
        if (clickedOnEmpty) {
            selectShape(null);
            handleSelectedDisplayTextTab(undefined);

            setSelectedImage(null);
        }
    };

    const handleSelectedShape = (itemKey) => {
        const existingQuote = {...quote};
        const selectedTextItem = existingQuote.displayTextItems[itemKey];
        handleSelectedDisplayTextTab(selectedTextItem);
    }

    const handleAttributeChanges = (textItem, index, newAttrs) => {
        const existingQuote = {...quote};
        existingQuote.displayTextItems[textItem.itemKey] = newAttrs;
        delete existingQuote.displayTextItems[textItem.itemKey].width;
        delete existingQuote.displayTextItems[textItem.itemKey].height;

        /*if (newAttrs.width && newAttrs.height) {
            delete newAttrs.fontSize;
        }*/

        setQuote(existingQuote);
    }

    const handleImageAttributeChanges = (imageItem, index, newAttrs) => {
        const existingImages = [...images];
        existingImages[index] = newAttrs;

        setImages(existingImages);
    }

    const handleExport = () => {
        /*selectShape(null);
        handleSelectedDisplayTextTab(undefined);*/
        const stage = stageRef.current;
        stage.scale({x: 1, y: 1});
        stage.width(quote.settings.width * 1);
        stage.height(quote.settings.height * 1);

        const uri = stageRef.current.toDataURL({
            pixelRatio: 4
        });
        downloadURI(uri, 'stage.png');
    };

    const handleWheel = (event) => {
        event.evt.preventDefault();

        const scaleBy = 1.02;
        const stage = event.target.getStage();
        const oldScale = stage.scaleX();
        const mousePointTo = {
            x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
            y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale
        };

        const newScale = event.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;
        setStageScale(newScale);

        /*const stage = stageRef.current;
        stage.width(quote.settings.width * scale);
        stage.height(quote.settings.height * scale);*/
        stage.scale({x: newScale, y: newScale});

        stage.width(quote.settings.width * newScale);
        stage.height(quote.settings.height * newScale);

        /*setStagePos({
            x: -(mousePointTo.x - stage.getPointerPosition().x / newScale) * newScale,
            y: -(mousePointTo.y - stage.getPointerPosition().y / newScale) * newScale
        });*/
    }

    const handleImageDragOver = (event) => {
        event.preventDefault();
    }

    const setCurrentImageSize = () => {
        return new Promise<void>((resolve) => {
            if (currentImage && (!currentImage.width || !currentImage.height)) {
                reactImageSize(currentImage.fileUrl)
                    .then(({width, height}) => {
                        currentImage.width = width;
                        currentImage.height = height;

                        resolve();
                    })
                    .catch((errorMessage) => {
                        console.log('errorMessage: ', errorMessage);
                    });
            } else {
                resolve();
            }
        });
    }

    const handleImageDropEnd = async (event) => {
        event.preventDefault();
        // register event position
        // @ts-ignore
        stageRef.current.setPointersPositions(event);
        const pointerPosition = stageRef.current.getPointerPosition();
        console.log('pointerPosition: ', pointerPosition);
        console.log('currentImage: ', currentImage);

        await setCurrentImageSize();

        let height = currentImage.height / 10;
        let width = currentImage.width / 10;
        let ratio = 1;

        if (currentImage.width > currentImage.height) {
            ratio = currentImage.width / currentImage.height;
        } else {
            ratio = currentImage.height / currentImage.width;
        }

        height = height * ratio;
        width = width * ratio;

        // console.log('height: ', height, ' | width: ', width, ' | ratio: ', ratio);

        // add image
        // @ts-ignore
        setImages(
            images.concat([
                {
                    ...pointerPosition,
                    width: width,
                    height: height,
                    id: currentImage?.id,
                    src: currentImage?.fileUrl,
                },
            ])
        );
    }

    return (
        <>

            <div className="flex justify-start items-center p-4 ">
                <button onClick={handleExport}
                        className="px-4 py-2 rounded bg-gray-200 border border-gray-500">Export
                </button>
            </div>

            <div id="stage-parent" className="flex justify-start p-10"
                 onDrop={handleImageDropEnd}
                 onDragOver={handleImageDragOver}>
                <Stage width={stageWidth} height={stageHeight}
                       className="flex justify-start bg-yellow-50 border border-gray-800 shadow-lg"
                       onClick={checkDeselect}
                       onMouseDown={checkDeselect}
                       onTouchStart={checkDeselect}
                       draggable
                       perfectDrawEnabled={false}
                       ref={stageRef}
                       scaleX={stageScale}
                       scaleY={stageScale}
                       x={stagePos.x}
                       y={stagePos.y}
                       onWheel={handleWheel}
                       onDragEnd={e => {
                           setStagePos(e.currentTarget.position());
                       }}>

                    {/*<Layer>{gridComponents}</Layer>*/}

                    {/*<Layer ref={gridLayerRef}>
                        {gridLinesX.map((gridLine, i) => {
                            return (
                                <Line
                                    key={i}
                                    {...gridLine}
                                />
                            )
                        })}
                        <Line points={[0, 0, 10, 10]}/>
                        {gridLinesY.map((gridLine, i) => {
                            return (
                                <Line
                                    key={i}
                                    {...gridLine}
                                />
                            )
                        })}
                    </Layer>*/}

                    {/*<Layer>
                        {rectangles.map((rect, i) => {
                            return (
                                <ShowText
                                    key={i}
                                    shapeProps={rect}
                                    isSelected={rect.id === selectedId}
                                    onSelect={() => {
                                        selectShape(rect.id);
                                    }}
                                    onChange={(newAttrs) => {
                                        const rects = rectangles.slice();
                                        rects[i] = newAttrs;
                                        setRectangles(rects);
                                    }}
                                />
                            )
                        })}
                    </Layer>*/}

                    <Layer>
                        {images.map((imageDetail, index) => {
                            return <ImageItem
                                key={imageDetail.id}
                                shapeProps={imageDetail}
                                isSelected={imageDetail.id === selectedImage?.id}
                                onSelect={() => {
                                    setSelectedImage(imageDetail);
                                    selectShape(null);
                                }}
                                onChange={(newAttrs) => {
                                    setImageDetail(newAttrs);
                                    handleImageAttributeChanges(imageDetail, index, newAttrs);
                                }}
                            />;
                        })}
                    </Layer>

                    <Layer>
                        <Group>
                            {quote?.displayTextItems?.map((textItem, index) => (
                                <TextShape
                                    key={textItem?.itemKey}
                                    shapeProps={textItem}
                                    isSelected={textItem?.itemKey === selectedId}
                                    onSelect={(updatedAttrs) => {
                                        selectShape(textItem?.itemKey);
                                        setSelectedImage(null);
                                        handleSelectedShape(textItem?.itemKey);
                                    }}
                                    onChange={(newAttrs) => {
                                        /* const tempDisplayTextItems = quote?.displayTextItems.slice();
                                         tempDisplayTextItems[index] = newAttrs;*/
                                        handleAttributeChanges(textItem, index, newAttrs);
                                        // setRectangles(tempDisplayTextItems);
                                    }}
                                />
                                /*<Text key={index}
                                      draggable={true}
                                      x={50}
                                      y={100 + 100 * index}
                                      text={textItem.text}
                                      fill={`${textItem.hexCode}`}
                                    /!*skewX={-.5}*!/
                                    /!*stroke={'green'}
                                    strokeWidth={3}
                                    shadowColor={'#94a3b8'}
                                    shadowBlur={10}
                                    shadowOffsetX={5}
                                    shadowOffsetY={5}
                                    shadowForStrokeEnabled={true}
                                    fillAfterStrokeEnabled={true}*!/
                                      fontSize={textItem.fontSize}
                                      fontFamily={`${textItem.fontFamily}`}
                                />*/
                            ))}
                        </Group>
                    </Layer>

                </Stage>
            </div>
        </>
    )
}

export default QuoteKonvaEditor
